<template>
  <div class="d-flex flex-column align-items-center" :class="{ 'w-100': isIE }">
    <div class="d-flex align-items-center ctls" :class="{ 'w-100': isIE }">
      <div
        class="d-flex align-items-center justify-content-center position-relative overflow-hidden arrow prev"
        @click="$emit('arrowClick', 1)"
      >
        <arrow-vect class="position-relative"/>
      </div>

      <div
        class="d-flex align-items-stretch overflow-hidden text-center backface-hidden titles-wrap"
        :class="{ 'w-100': isIE }"
      >
        <div
          class="d-flex flex-nowrap align-items-center mw-100 titles-inner"
          :style="{ transform: 'translateX(' + transAmt + '%)' }"
          :class="{ 'w-100': isIE }"
        >
          <p class="w-100 adobe-clean title" v-html="slides[max].title"></p>
          <p class="w-100 adobe-clean title" v-for="slide in slides" v-html="slide.title"></p>
          <p class="w-100 adobe-clean title" v-html="slides[0].title"></p>
        </div>
      </div>

      <div
        class="d-flex align-items-center justify-content-center position-relative overflow-hidden arrow next"
        @click="$emit('arrowClick', -1)"
      >
        <arrow-vect class="position-relative"/>
      </div>
    </div>
    <div class="d-flex dots">
      <div class="dot" :style="[ idx === active ? { opacity: 1 } : { opacity: 0.5 } ]" v-for="(_, idx) in slides"></div>
    </div>
  </div>
</template>

<script>
  import ArrowVect from '@/components/svg/ArrowVect'
  import StateMixin from '@/components/report/mixins/StateMixin'

  export default {
    name: 'CarouselCtls',
    mixins: [ StateMixin ],
    props: {
      slides: { type: Array, required: true },
      active: { type: Number, required: true },
      transAmt: { type: Number, required: true },
      max: { type: Number, required: true }
    },
    components: { ArrowVect }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/global/the_goods";

  .ctls {
    max-width : 100%;

    @include screen-md-lg-xl {
      max-width : 500px;
    }
  }

  .arrow {
    width  : viewport-scale(36);
    height : viewport-scale(36);
    flex   : 0 0 viewport-scale(36);

    @include screen-md-lg-xl {
      width  : rem(36);
      height : rem(36);
      flex   : 0 0 rem(36);
    }

    &::before {
      content       : '';
      border-radius : 50%;
      background    : rgba(0, 0, 0, 0.2);
      position      : absolute;
      top           : 0;
      bottom        : 0;
      left          : 0;
      right         : 0;
    }

    .arrow-vect {
      width     : viewport-scale(7.55);
      height    : viewport-scale(16.54);
      transform : translate(-1px, -1px);

      @include screen-md-lg-xl {
        width  : rem(7.55);
        height : rem(16.54);
      }
    }

    &.next .arrow-vect {
      transform : translate(1px, -1px) rotate(180deg);
    }
  }

  .titles-wrap {
    margin : 0 rem(8);
  }

  .title {
    font-size : rem(20);
    flex      : 0 0 100%;

    .style-extended & {
      font-size : rem(22);
    }

    @include screen-md-lg-xl {
      font-size : rem(22);
    }
  }

  .dot {
    width         : viewport-scale(6);
    height        : viewport-scale(6);
    background    : #fff;
    border-radius : 50%;
    transition    : opacity #{$data-trans-time / 4};
    margin        : 0 viewport-scale(4);

    @include screen-md-lg-xl {
      width  : rem(6);
      height : rem(6);
      margin : 0 rem(4);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/CarouselCtls.vue